export enum treasuryTestTopUpFormFields {
  amount = 'amount',
  processNow = 'processNow',
}
